import Window from './window'
export default Window